import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PprHomePageComponent } from './ppr-home-page/ppr-home-page.component';

// If path starts with fetch, go to the DataOverview Module and then choose from those routes
const routes: Routes = [
  {
    path: 'ppr',
    pathMatch: 'full',
    component: PprHomePageComponent
  },
  {
    path: 'ppr/generate/yearlyReport',
    loadChildren: () => import('./yearlyReport/yearly-report.module').then(module => module.YearlyReportModule) 
  },
  {
    path: 'ppr/generate/assetManagersReport',
    loadChildren: () => import('./assetManagersReport/asset-managers-report.module').then(module => module.AssetManagersReportModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
